import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';

const MasterEntityPage = Loadable(lazy(() => import('./components/master-entity-page/MasterEntityPage')));

export const systemConfigurationRoutes = {
  path: 'system-config',
  children: [
    { index: true, element: <Navigate to="company" replace /> },
    { path: ':entity', element: <MasterEntityPage /> }
  ]
};

export default systemConfigurationRoutes;
